// import { gsap } from 'gsap';
import UIkit from 'uikit';

export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        document.addEventListener("DOMContentLoaded", initialize);
        // window.addEventListener('resize', resizeFunctions);
        function initialize() {
            //animateLogo
            // animateLogo();
            // initialize mailTo
            initMailTo();
            // initialize ajax for forms
            // todo: change the classes to our specific ones!!!
            // initFormsFromBuilder()
            // add class to toggle switch
            switchClasses();
            initYoutubeVideos();
        }


        // function resizeFunctions() {
        //
        // }

        // function animateLogo() {
        //     var ball = document.getElementById('ball');
        //     gsap.set(ball, {x:-300, y:-70});
        //     var tl = gsap.timeline({delay:0.5});
        //     tl
        //         .to(ball, 1.25, { x:0 }, "bounce")
        //         .to(ball, 1.25, { y:0, ease: "bounce.out"}, "bounce")
        //         .to(ball, 1.25, { transformOrigin: "50% 50%", force3D: true, rotation: "+=360", ease: "power0.easeNone" }, "bounce" )

        // }


        function switchClasses() {
            UIkit.util.on('.uk-offcanvas', 'show', function (e) {
                document.querySelector('[href="#' + this.getAttribute('id') + '" ]').classList.add('open');
            });
            UIkit.util.on('.uk-offcanvas', 'hide', function (e) {
                document.querySelector('[href="#' + this.getAttribute('id') + '" ]').classList.remove('open');
            });
        }


        /* Mailto */
        function initMailTo() {
            let emails = document.getElementsByClassName("liame");
            for (let i = 0; i < emails.length; i += 1) {
                emails[i].addEventListener('click', function () {
                    let email = this.textContent;

                    email = email.replace('null', '').split('').reverse().join('');
                    document.location.href = 'mailto:' + email;
                });
            }
        }



        /* Add event listener to form to submit it via ajax */
        // function initFormsFromBuilder() {
        //     let builderForms = document.querySelectorAll(".FormBuilder form");
        //     for (let i = 0; i < builderForms.length; i += 1) {
        //         builderForms[i].addEventListener('submit', function (e)
        //         {
        //             e.preventDefault();
        //             let thisForm = this;
        //             let httpRequest = new XMLHttpRequest();
        //             httpRequest.onreadystatechange = function (data) {
        //                  // request finished and response is ready && request is successfully handled by the Server 
        //                 if (httpRequest.readyState == 4 && httpRequest.status == 200)
        //                 {
        //                     /*----------------------------- CHECK THE REGEX FOR THE CLASSES WE USE!!!!  ----------------------*/
        //                     let errors = httpRequest.responseText.match(/<div\b[^>]*class='FormBuilderErrors'[^>]*>([\s\S]*?)<\/div>/);
        //                     if (errors) {
        //                         let errorsDiv = thisForm.closest('.FormBuilder').querySelector('.FormBuilderErrors');
        //                         if(errorsDiv) {
        //                             errorsDiv.innerHTML = errors[1];
        //                         }
        //                         else {
        //                             let div = document.createElement('div');
        //                             div.innerHTML = errors[1];
        //                             div.className = 'FormBuilderErrors';
        //                             thisForm.parentNode.insertBefore(div, thisForm);
        //                         }
        //                     }
        //                     else {
        //                         let success = httpRequest.responseText.match(/<p\b[^>]*class='success'[^>]*>([\s\S]*?)<\/p>/);
        //                         if(success) {
        //                             thisForm.closest('.FormBuilder').innerHTML = success[0];
        //                         }

        //                     }
        //                 }
        //             }
        //             httpRequest.open('POST', './');
        //             httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        //             httpRequest.send(serialize(this));
        //         })
        //     }
        // }


        /*!
        * Serialize all form data into a query string
        * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
        * @param  {Node}   form The form to serialize
        * @return {String}      The serialized form data
        */
        // var serialize = function (form) {

        //     // Setup our serialized data
        //     var serialized = [];

        //     // Loop through each field in the form
        //     for (var i = 0; i < form.elements.length; i++) {

        //         var field = form.elements[i];

        //         // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        //         if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        //         // If a multi-select, get all selections
        //         if (field.type === 'select-multiple') {
        //             for (var n = 0; n < field.options.length; n++) {
        //                 if (!field.options[n].selected) continue;
        //                 serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
        //             }
        //         }

        //         // Convert field data to a query string
        //         else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
        //             serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
        //         }
        //     }

        //     return serialized.join('&');

        // };

        function initYoutubeVideos() {
            let videos = document.getElementsByClassName("youtube-player");
            for (let i = 0; i < videos.length; i += 1) {
                videos[i].addEventListener('click', function () {
                    const iframe = document.createElement('iframe'),
                        videoID = videos[i].getAttribute('data-id'),
                        iFrameUrl = '//www.youtube.com/embed/' + videoID + '?autoplay=1&rel=0';

                    iframe.setAttribute('src', iFrameUrl);
                    videos[i].replaceWith(iframe);
                });
            }
        }

    },
};
